export default __webpack_public_path__ + "static/media/3.56bc9aa6.png";